<template>
  <a-modal
    title="添加头像"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :destroyOnClose="true"
    :width="400"
    header="null"
    okText="提交"
    cancelText="取消"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-row type="flex" justify="center">
      <a-col :span="7">
        <Upload ref="upload" @uploadSuccess="uploadSuccess" :fixedNumber="[5, 7]" ></Upload>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
import Upload from '@comm/upload/Upload'
export default {
  components: {
    Upload
  },
  data () {
    return {
      visible: false,
      confirmLoading: false,
      agencyId: this.$route.query.agencyId,
      head: null,
      player: {
        cardId: null,
        name: null,
        head: null
      }
    }
  },
  methods: {
    show (player, index) {
      player['index'] = index
      this.player = player
      this.visible = true
    },
    handleOk () {
      if (this.head == null) {
        this.$message.error('请选择头像')
        return
      }
      this.postData()
    },
    handleCancel () {
      this.player = {
        cardId: null,
        name: null,
        head: null
      }
      this.visible = false
    },
    uploadSuccess (fileList) {
      if (fileList.length > 0) {
        this.head = fileList[0].url
      } else {
        this.head = null
      }
    },
    postData () {
      let params = {
        agencyId: this.agencyId,
        cardId: this.player.cardId,
        head: this.head
      }
      this.confirmLoading = true
      this.$api.join.addPlayerHead(params).then(res => {
        if (res.status === 0) {
          this.$message.success('绑定成功')
          this.player.head = this.head
          this.$emit('bindSuccess', this.player)
          this.handleCancel()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log('err', err)
        this.$message.error('操作失败')
      }).finally(_ => {
        this.confirmLoading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comm/components/join/player/BindPlayerHead.vue